<template>
    <a-modal v-model:visible="rewardsVisible" wrapClassName="activity-modal" :width="modalWidth" :footer="null" :centered="true">
        <template #title>
            <span class="px-35 text-black Poppins-SemiBold font-semibold lg:(j-px-40 j-text-30 j-leading-50)">
                {{ t('member_index.banner.my_rewards') }}
            </span>
        </template>
        <div class="px-35 pb-0 flex items-start flex-col lg:(j-px-40 j-pb-15 items-center justify-between flex-row)">
            <ul class="flex w-full h-62 bg-#DBDBDB rounded-8 lg:(w-auto j-h-50 j-rounded-6)">
                <li
                    class="w-full lg:w-auto p-3 lg:j-p-2 group"
                    :class="activeType === 'unused' ? 'active' : ''"
                    @click.prevent="switchType('unused', t('member_index.banner.unused'))"
                >
                    <span class="list-type-item">{{ t('member_index.banner.unused') }}</span>
                </li>
                <li
                    class="w-full lg:w-auto p-3 lg:j-p-2 group"
                    :class="activeType === 'toBeRedeemed' ? 'active' : ''"
                    @click.prevent="switchType('toBeRedeemed', t('member_index.banner.to_be_redeemed'))"
                >
                    <span class="list-type-item">{{ t('member_index.banner.to_be_redeemed') }}</span>
                </li>
            </ul>
            <p
                class="my-20 lg:j-my-0 lg:j-text-20 Poppins-SemiBold font-semibold text-black"
            >{{ activeType === 'unused' ? t('member_index.redeem_points.unusedTips') : t('member_index.redeem_points.pointTips', [props.points]) }}</p>
        </div>
        <div
            class="px-30 py-10 lg:j-p-15 h-720 lg:j-h-500 overflow-y-auto"
            :class="noData ? 'lg:j-p-8' : ''"
        >
            <template v-if="dataLoding">
                <div class="w-full flex-center flex-col h-700 lg:j-h-482 rounded-12 lg:j-rounded-8 bg-white text-primary">
                    <loading-outlined /> &nbsp; {{ t('tips.loading') }}
                </div>
            </template>

            <template v-else>
                <div v-if="couponData[activeType].length">
                    <h2 class="px-5 py-10 lg:j-px-25 lg:j-py-10-Semibold Poppins font-semibold text-28 lg:j-text-22 text-regular">{{ t('member_index.redeem_points.category_tabs.coupon') }}</h2>
                    <div
                        class="grid justify-items-center gap-18 mb-20 lg:j-gap-15 lg:j-mb-20"
                        :class="[ mobile ? 'grid-cols-2' : 'grid-cols-3']"
                    >
                        <template v-for="item in couponData[activeType]" :key="item">
                            <SwiperCardItem
                                :mobile="mobile"
                                :item="item"
                                type="Coupon"
                                :isLogin="props.isLogin"
                                :isModal="true"
                            />
                        </template>
                    </div>
                </div>
                <div v-if="giftcardData[activeType].length">
                    <h2 class="px-5 py-10 lg:j-px-25 lg:j-py-10 Poppins-SemiBold font-semibold text-28 lg:j-text-22 text-regular">{{ t('member_index.redeem_points.category_tabs.gift_card') }}</h2>
                    <div
                        class="grid justify-items-center gap-18 mb-20 lg:j-gap-15 lg:j-mb-20"
                        :class="[ mobile ? 'grid-cols-2' : 'grid-cols-3']"
                    >
                        <template v-for="item in giftcardData[activeType]" :key="item">
                            <SwiperCardItem
                                :mobile="mobile"
                                :item="item"
                                type="Gift-Card"
                                :isLogin="props.isLogin"
                                :isModal="true"
                            />
                        </template>
                    </div>
                </div>
                <div v-if="couponThingData[activeType].length">
                    <h2 class="px-5 py-10 lg:j-px-25 lg:j-py-10 Poppins-SemiBold font-semibold text-28 lg:j-text-22 text-regular">{{ t('member_index.redeem_points.category_tabs.jackery_products') }}</h2>
                    <div
                        class="grid justify-items-center gap-18 mb-20 lg:j-gap-15 lg:j-mb-20"
                        :class="[ mobile ? 'grid-cols-2' : 'grid-cols-3']"
                    >
                        <template v-for="item in couponThingData[activeType]" :key="item">
                            <SwiperCardItem
                                :mobile="mobile"
                                :item="item"
                                type="Products"
                                :isLogin="props.isLogin"
                                :isModal="true"
                            />
                        </template>
                    </div>
                </div>
                <div v-if="virtualCardsData[activeType].length">
                    <h2 class="px-5 py-10 lg:j-px-25 lg:j-py-10 Poppins-SemiBold font-semibold text-28 lg:j-text-22 text-regular">{{ t('member_index.redeem_points.category_tabs.virtualCard') }}</h2>
                    <div
                        class="grid justify-items-center gap-18 mb-20 lg:j-gap-15 lg:j-mb-20"
                        :class="[ mobile ? 'grid-cols-2' : 'grid-cols-3']"
                    >
                        <template v-for="item in virtualCardsData[activeType]" :key="item">
                            <SwiperCardItem
                                :mobile="mobile"
                                :item="item"
                                type="VirtualCard"
                                :isLogin="props.isLogin"
                                :isModal="true"
                            />
                        </template>
                    </div>
                </div>
                <div v-if="noData" class="w-full flex-center flex-col py-200 lg:j-py-104 bg-white">
                    <img
                        class="w-417 h-218 lg:(j-w-313 j-h-210) object-cover"
                        src="https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/lQLPJyA8mmi9M3rNAanNAmiw7oeyMcQSICUEZ4ZgpQASAA_616_425.png?v=1685097827"
                        alt=""
                    >
                    <p class="mt-55 text-32 leading-32 text-black Poppins-SemiBold font-semibold lg:(j-mt-40 j-text-24 j-leading-24)">
                        {{ noDataTips }}
                    </p>
                </div>
            </template>
        </div>
    </a-modal>
</template>

<script setup>
    import SwiperCardItem from '../main/SwiperCardItem.vue'
    import { LoadingOutlined, } from '@ant-design/icons-vue';
    import {
        getCustomerCouponsList, getCustomerCouponsThingList,
        getCustomerGiftcardList, getCustomerVirtualCardsList, 
        getMyRewardsCoupons, getMyRewardsGiftCard,
        getMyRewardsThings, getMyRewardsVirtualCard,
    } from "@a/index";
    import { breakpointsTailwind, useBreakpoints, useWindowSize, } from '@vueuse/core'
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useStore } from 'vuex';

    const { t } = useI18n();
    const store = useStore();

    const props = defineProps({
        isLogin: Boolean,
        points: String | Number,
    })

    const userInfo = computed(() => store.getters.userInfo);
    const language = computed(() => store.getters.language.current);

    const couponData = reactive({
        unused: [],
        toBeRedeemed: [],
    })
    const giftcardData = reactive({
        unused: [],
        toBeRedeemed: [],
    })
    const couponThingData = reactive({
        unused: [],
        toBeRedeemed: [],
    })
    const virtualCardsData = reactive({
        unused: [],
        toBeRedeemed: [],
    })

    // 无数据
    const noData = computed(() =>
        !couponData[activeType.value].length && 
        !giftcardData[activeType.value].length && 
        !couponThingData[activeType.value].length && 
        !virtualCardsData[activeType.value].length
    )

    const dataLoding = ref(true)

    const resetData = () => {
        couponData['unused'] = []
        couponData['toBeRedeemed'] = []

        giftcardData['unused'] = []
        giftcardData['toBeRedeemed'] = []

        couponThingData['unused'] = []
        couponThingData['toBeRedeemed'] = []

        virtualCardsData['unused'] = []
        virtualCardsData['toBeRedeemed'] = []
    }


    // 获取数据 通用方法
    const getData = async (method, params) => {
        dataLoding.value = true
        return await method(params)
    }

    // 切换 type 类型
    const activeType = ref('unused')
    const noDataTips = ref('')
    const switchType = (type, name) => {

        activeType.value = type

        resetData()

        const isUnusedType = activeType.value === 'unused'

        noDataTips.value = isUnusedType
            ? t('member_index.banner.no_unused_rewards')
            : t('member_index.banner.no_convertible_rewards')

        const params = {
            shopId: language.value.shop_id,
            exchangeType: isUnusedType ? null : activeType.value,
        }

        const COUPON_METHOD = isUnusedType ? getMyRewardsCoupons : getCustomerCouponsList
        const GIFT_CARD_METHOD = isUnusedType ? getMyRewardsGiftCard : getCustomerGiftcardList
        const THINGS_METHOD = isUnusedType ? getMyRewardsThings : getCustomerCouponsThingList
        const VIRTUALCARD_METHOD = isUnusedType ? getMyRewardsVirtualCard : getCustomerVirtualCardsList

        getData(COUPON_METHOD, params)
            .then(data => {
                couponData[type] = isUnusedType ? (data || []) : (data?.rights || [])
            })
            .catch(() => {
                couponData[type] = []
            })
            .finally(() => {
                dataLoding.value = false
            })

        getData(GIFT_CARD_METHOD, params)
            .then(data => {
                giftcardData[type] = isUnusedType
                    ? (data || []).filter(item => item.remainStatus === '0') // 只显示未使用的
                    : (data?.rights || [])
            })
            .catch(() => {
                giftcardData[type] = []
            })
            .finally(() => {
                dataLoding.value = false
            })

        getData(THINGS_METHOD, params)
            .then(data => {
                couponThingData[type] = isUnusedType ? (data || []) : (data?.rights || [])
            })
            .catch(() => {
                couponThingData[type] = []
            })
            .finally(() => {
                dataLoding.value = false
            })

        getData(VIRTUALCARD_METHOD, params)
            .then(data => {
                virtualCardsData[type] = isUnusedType ? (data || []) : (data?.rights || [])
            })
            .catch(() => {
                virtualCardsData[type] = []
            })
            .finally(() => {
                dataLoding.value = false
            })
        const gaParams = {
            jackery_id: userInfo.value.userName,
            button_name: name
        }
        gaPushDataLayer( gaParams)
    }


    const breakpoints = useBreakpoints(breakpointsTailwind)
    const mobile = breakpoints.smaller('lg')

    const { width, } = useWindowSize()
    const modalWidth = computed(() => mobile.value ? (width.value / 7.5) * 9.2 : (width.value / 19.2) * 9.2)


    const rewardsVisible = ref(false)

    const openModal = async () => {
        rewardsVisible.value = true

        activeType.value = 'unused'

        // 重置数据
        resetData()

        switchType(activeType.value, t('member_index.banner.unused'))
    }
    defineExpose({
        openModal,
    })
</script>

<style scoped>
    .list-type-item {
    @apply
        w-full lg:j-min-w-150 lg:j-px-25 h-full flex-center text-black/60 text-28 lg:j-text-16 cursor-pointer
        rounded-8 lg:j-rounded-6 Poppins-Medium font-medium
        group-[.active]:(bg-primary text-white)
    }

    @media screen and (max-width: 1024px) {
        :deep(.ant-modal-wrap .list-item-content) {
            flex: 1;
        }
    }
</style>
